import { Platform, StyleSheet, View, type ViewStyle } from 'react-native';
import { Parallax } from './Parallax';

interface GlowOrbProps {
  color: string;
  /** Diameter in px. */
  size: number;
  /** Absolute placement within the parent. */
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
  /** Parallax drift rate. */
  speed?: number;
}

/**
 * A soft, blurred ambient glow that drifts at a parallax rate. Decorative only —
 * place inside a relatively-positioned, overflow-hidden section behind content.
 */
export const GlowOrb = ({ color, size, top, bottom, left, right, speed = 0.22 }: GlowOrbProps) => {
  const position: ViewStyle = { top, bottom, left, right };
  return (
    <Parallax speed={speed} decorative style={[styles.wrapper, position]}>
      <View
        style={[
          styles.orb,
          { width: size, height: size, borderRadius: size / 2, backgroundColor: color },
          webBlur,
        ]}
      />
    </Parallax>
  );
};

// react-native-web supports CSS `filter`; native falls back to the soft
// low-alpha circle (still reads as an ambient glow on the dark canvas).
const webBlur = Platform.select({
  web: { filter: 'blur(80px)' } as unknown as ViewStyle,
  default: {},
});

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    pointerEvents: 'none',
  },
  orb: {
    opacity: 0.5,
  },
});
